import { FC } from 'react';
import { Switch } from 'antd';
import { SwitchProps } from 'antd/lib/switch';

export type { SwitchProps };

const ProSwitch: FC<SwitchProps> = props => {
  return <Switch {...props} />;
};
export default ProSwitch;
